import { render, staticRenderFns } from "./WeekAppointmentCard.vue?vue&type=template&id=3b8e56c6"
import script from "./WeekAppointmentCard.vue?vue&type=script&lang=js"
export * from "./WeekAppointmentCard.vue?vue&type=script&lang=js"
import style0 from "./WeekAppointmentCard.vue?vue&type=style&index=0&id=3b8e56c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports